import {logEvent, setUserId} from 'firebase/analytics';
import {getAuth, type User} from 'firebase/auth';
import {
  createContext,
  useEffect,
  useState,
  type PropsWithChildren,
} from 'react';
import {getOptionalAnalytics} from 'firebaseApp';

interface FirebaseAuthContextData {
  isSignedIn: boolean;
  providerId: string | null;
  user: User | null;
}

const DEFAULT_FIREBASE_AUTH_VALUES = {
  isSignedIn: false,
  providerId: null,
  user: null,
};

const FirebaseAuthContext = createContext<FirebaseAuthContextData>(
  DEFAULT_FIREBASE_AUTH_VALUES,
);

 
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
export const FirebaseAuthProvider = ({children}: PropsWithChildren<{}>) => {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [providerId, setProviderId] = useState<string | null>(null);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged(user => {
      setIsSignedIn(!!user);
      setProviderId(user?.providerData?.[0]?.providerId ?? null);
      setUser(user);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!isSignedIn) {
      return;
    }
    const analytics = getOptionalAnalytics();
    if (!analytics) {
      return;
    }
    setUserId(analytics, user?.uid);
    logEvent(analytics, 'login');
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [isSignedIn]);

  return (
    <FirebaseAuthContext.Provider value={{isSignedIn, providerId, user}}>
      {children}
    </FirebaseAuthContext.Provider>
  );
};
